"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageProviders = exports.authTypes = void 0;
var AppUtil_1 = require("./AppUtil");
var LOGINLEVEL_KEY = 'yw_ll';
var SESSION_LIFETIME_KEY = 'yw_sl';
var LOGINTYPE_KEY = 'yw_lt';
exports.authTypes = {
    user: 'usr',
    orgSelect: 'org',
    external: 'ext',
    public: 'pub',
};
exports.storageProviders = {
    session: 'Session',
    local: 'Local',
};
var storageProvider = window.localStorage;
var initialized = false;
var Auth = /** @class */ (function () {
    function Auth() {
    }
    Auth.setStorageProvider = function (provider) {
        switch (provider) {
            case exports.storageProviders.local:
                storageProvider = window.localStorage;
                break;
            case exports.storageProviders.session:
                storageProvider = window.sessionStorage;
                break;
            default:
                storageProvider = window.localStorage;
                break;
        }
    };
    Auth.isUserAuthenticated = function () {
        var acceptedTypes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            acceptedTypes[_i] = arguments[_i];
        }
        if (!initialized) {
            // Check to see if old session is stored in sessionStorage
            if (Number(window.sessionStorage.getItem(LOGINLEVEL_KEY)) > 0) {
                this.setStorageProvider(exports.storageProviders.session);
            }
            initialized = true;
        }
        var hasLoginLevel = this.getLoginLevel() > 0;
        if (!hasLoginLevel)
            return false;
        if ((acceptedTypes === null || acceptedTypes === void 0 ? void 0 : acceptedTypes.length) > 0) {
            var loggedInType = this.getLoginType();
            return acceptedTypes.indexOf(loggedInType) > -1;
        }
        return true;
    };
    Auth.deauthenticateUser = function () {
        window.localStorage.setItem(LOGINLEVEL_KEY, '');
        window.sessionStorage.setItem(LOGINLEVEL_KEY, '');
        window.localStorage.setItem(SESSION_LIFETIME_KEY, '');
        window.sessionStorage.setItem(SESSION_LIFETIME_KEY, '');
        window.localStorage.setItem(LOGINTYPE_KEY, '');
        window.sessionStorage.setItem(LOGINTYPE_KEY, '');
        (0, AppUtil_1.PostAppMessage)(AppUtil_1.APPMessages.LoggedInLevel, 0);
    };
    Auth.getLoginLevel = function () {
        return Number(storageProvider.getItem(LOGINLEVEL_KEY)) || 0;
    };
    Auth.getSessionLifetime = function () {
        return Number(storageProvider.getItem(SESSION_LIFETIME_KEY)) || 0;
    };
    Auth.getLoginType = function () {
        return storageProvider.getItem(LOGINTYPE_KEY);
    };
    Auth.setLoginInfo = function (level, sessionLifetime, authType, useSessionWithoutLifetime) {
        if (sessionLifetime || useSessionWithoutLifetime) {
            this.setStorageProvider(exports.storageProviders.session);
        }
        else {
            this.setStorageProvider(exports.storageProviders.local);
        }
        storageProvider.setItem(LOGINLEVEL_KEY, (level === null || level === void 0 ? void 0 : level.toString()) || '');
        storageProvider.setItem(SESSION_LIFETIME_KEY, (sessionLifetime === null || sessionLifetime === void 0 ? void 0 : sessionLifetime.toString()) || '');
        storageProvider.setItem(LOGINTYPE_KEY, authType || '');
        (0, AppUtil_1.PostAppMessage)(AppUtil_1.APPMessages.LoggedInLevel, level);
    };
    return Auth;
}());
exports.default = Auth;
